var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.inputValue)},on:{"blur":_vm.blur,"input":function($event){if($event.target.composing)return;_vm.inputValue=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }